import { render, staticRenderFns } from "./thirdPartyUserAdd.vue?vue&type=template&id=7fa65588&"
import script from "./thirdPartyUserAdd.vue?vue&type=script&lang=js&"
export * from "./thirdPartyUserAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports